// Regras de "Cliente estrangeiro" compartilhadas entre o cadastro de pessoas
// (domains/people) e o modal de check-in (domains/checkin). Ficam aqui, e nao dentro
// de um dos dominios, para que um nao precise importar do outro (AD-010).

const NATIONAL_DOC_FIELDS = ['documentCPF', 'documentRG'];
const FOREIGN_DOC_FIELDS = ['documentOther', 'passportCountryCode'];

// Fallback de leitura: desde AD-008 a fonte da verdade e Person.IsForeigner, vinda do
// backend. Esta deteccao cobre o registro cuja coluna ainda nao reflita a intencao do
// usuario — instalacao com backend antigo, ou pessoa criada antes do backfill.
export const detectForeigner = (data = {}) => (
    !!data.documentOther && !data.documentCPF && !data.documentRG
);

// So o "true" de IsForeigner e confiavel: o totem nao manda a flag e o backend grava false a
// cada check-in dele. Por isso a flag soma com a deteccao em vez de substitui-la; confiar no
// false abria o estrangeiro do totem em modo nacional e o check-in por foto falhava (AD-019).
// E o "true" so vale com um documento de estrangeiro para usar: sem ele o check-in sairia como
// "Outro Documento" vazio e o CheckIn falharia no banco (AD-021). Na busca por documento a
// resposta nao traz documentos, entao quem chama informa o que foi digitado.
export const resolveForeigner = (data = {}, documentOther = data.documentOther) => (
    (!!data.isForeigner && !!documentOther) || detectForeigner(data)
);

// Ao alternar a flag, limpamos os campos do modo anterior para nao enviar documento
// conflitante/obsoleto.
export const clearedFieldsOnToggle = isForeigner => (
    isForeigner ? [...NATIONAL_DOC_FIELDS] : [...FOREIGN_DOC_FIELDS]
);

// O switch vale '' antes do initialize e vira false/true quando a pessoa carrega. Troca de
// modo e so quando o valor booleano muda: comparar o valor cru tratava o '' -> false da
// abertura como troca, e abrir um brasileiro com passaporte apagava passaporte e pais (AD-018).
export const isForeignerToggle = (value, previous) => !!value !== !!previous;

export const nationalDocumentFields = () => [...NATIONAL_DOC_FIELDS];

export const foreignDocumentFields = () => [...FOREIGN_DOC_FIELDS];
